import { Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

export function nicerLoading(loading$: Observable<boolean>): Observable<boolean> {
  return loading$.pipe(
    switchMap((isSending) => {
      if (isSending) {
        return of(true);
      }
      // More satisfying UX for very fast requests
      return of(false).pipe(delay(350));
    }),
  );
}
